import { Navigate, Outlet } from 'react-router';

import { useMe } from '../lib/me';

/** For tidiness only: the API checks is_platform_admin on every platform route. */
export function RequirePlatformAdmin() {
  const { data: me } = useMe();
  if (!me) return null;
  return me.is_platform_admin ? <Outlet /> : <Navigate to="/" replace />;
}
